/** Reads browser persistence without letting unavailable storage or malformed JSON crash startup. */
function storedText(key, storage) {
  try { return (storage || window.localStorage)?.getItem(key) ?? null; }
  catch { return null; }
}

export function readStoredObject(key, storage) {
  const raw = storedText(key, storage);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    return value && typeof value === "object" && !Array.isArray(value) ? value : null;
  } catch { return null; }
}

/** Accepts both the legacy raw string and the current JSON-encoded string. */
export function readStoredString(key, storage) {
  const raw = storedText(key, storage);
  if (!raw) return null;
  let value;
  try { value = JSON.parse(raw); }
  catch {
    const text = raw.trim();
    if (/^[\[{\"]/.test(text)) return null;
    value = text;
  }
  return typeof value === "string" && value.trim() && !["null", "undefined"].includes(value.trim())
    ? value.trim() : null;
}

export function readStoredId(key, storage) {
  const raw = storedText(key, storage);
  if (!raw) return null;
  let value;
  try { value = JSON.parse(raw); } catch { return null; }
  if (typeof value !== "number" && !(typeof value === "string" && /^\d+$/.test(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
